// extracted by mini-css-extract-plugin
export default {"search":"FormationForm_search__ir5lH"};